// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__31C3e","rootSuccess":"CompleteLink_rootSuccess__5kz7K","rootFailure":"CompleteLink_rootFailure__Hyr7b","isDisabled":"CompleteLink_isDisabled__38Qt5"};